var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenRays(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "green_rays",
    "data-name": "green rays",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5182.9 5182.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b2c160;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1green_rays") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2626.04 2588.71 2572.69 2610.81 1390.41 133.82 1710.54 1.22 2626.04 2588.71"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2588.95 2573.63 2611.05 2626.99 135.53 3809.87 2.93 3489.74 2588.95 2573.63"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2572.83 2611.16 2626.18 2589.06 3808.46 5066.05 3488.33 5198.65 2572.83 2611.16"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2610.35 2627.28 2588.25 2573.92 5064.63 1393.12 5197.23 1713.24 2610.35 2627.28"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2610.31 2573.19 2588.21 2626.54 0.72 1711.04 133.32 1390.91 2610.31 2573.19"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2573.42 2588.75 2626.78 2610.85 1712.74 5197.73 1392.62 5065.13 2573.42 2588.75"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2588.56 2626.68 2610.66 2573.33 5198.15 3488.83 5065.55 3808.96 2588.56 2626.68"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2626.49 2611.55 2573.13 2589.45 3489.24 3.43 3809.37 136.03 2626.49 2611.55"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRays);
export default __webpack_public_path__ + "static/media/green_rays.9ec255edc16504d841301eb2af0c35da.svg";
export { ForwardRef as ReactComponent };